import type {
  UserRecord,
  AccountRecord,
  MembershipRecord
} from '@libs/data-access/entities'
import type { ReduxState } from '@spa/redux/ReduxState'
import { createStructuredSelector } from 'reselect'
import {
  getCurrentAccount,
  getCurrentAccountId
} from 'snap-redux/modules/accounts/selectors'
import { getCurrentMembershipSelector } from 'snap-redux/modules/memberships/selectors'
import {
  getCurrentUser,
  getCurrentUserId
} from 'snap-redux/modules/users/selectors'

const accountId = (state: ReduxState) => getCurrentAccountId(state)
const account = (state: ReduxState): AccountRecord => getCurrentAccount(state)

export const baseStructuredSelector = createStructuredSelector({
  getCurrentUserId,
  accountId,
  account
})

// @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
const currentUser = (state: ReduxState): UserRecord => getCurrentUser(state)
const currentMembership = (state: ReduxState): MembershipRecord =>
  getCurrentMembershipSelector(state)

export const currentUserSelector = createStructuredSelector({
  currentUser,
  currentMembership
})
